/** @format */
export const BASE_PATH = process.env.REACT_APP_BASE_URI || '';

export const drawerWidth = 240;

export const dimension = {
  width: window.innerWidth,
  height: window.innerHeight,
};

export const KEY_CONTEXT = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  USER: "user",
};

export const EmpLangSeclect = [
  {
    key: "EN",
    title: "English",
    value: "EN",
    useI18n: true,
  },
  {
    key: "VN",
    title: "Vietnamese",
    value: "VN",
    useI18n: true,
  },
];

export const defaultPagination = {
  total: 0,
  page: 0,
  pageSize: 25,
};

export enum EnumInputVariant {
  base = "base",
  browser = "browser",
  number = "number",
  select = "select",
}

export enum EnumValueDataType {
  String = "String",
  Number = "Number",
  Boolean = "Boolean",
  Object = "Object",
  Array = "Array",
  Null = "Null",
  Undefined = "Undefined",
  Function = "Function",
}

export const PUBLIC_URL = {
  LOGIN: "/auth/login",
};

export const PRIVATE_ROOT = {
  PROJECTS: "/projects",
  DASHBOARD: "/dashboard",
};

export const userStatus = [
  {
    name: 'Activate',
    value: '0'
  },
  {
    name: 'Blocked',
    value: '1'
  },
];
// planned,active,completed
export const sprintStatus = [
  {
    name: 'Đang hoạt động',
    value: 'active'
  },
  {
    name: 'Đã lên kế hoạch',
    value: 'planned'
  },
  {
    name: 'Đã hoàn thành',
    value: 'completed'
  },
];

export const ProjectActions = [
  {
    name: 'Sửa',
    icon: 'Pencil',
    value: 'edit'
  },
  {
    name: 'Đã xong',
    icon: 'Pencil',
    value: 'completed'
  },
  {
    name: 'Tạm dừng',
    icon: 'Pencil',
    value: 'hold'
  },
  {
    name: 'Chưa xử lý',
    icon: 'Pencil',
    value: 'pending'
  }
];

export const taskStatusOptions = [
  {
    name: 'Mở',
    value: 'open'
  },
  {
    name: 'Đóng',
    value: 'closed'
  },
];
//'low' | 'medium' | 'high'
export const priorityStatusOptions = [
  {
    name: 'Thấp',
    value: 'low'
  }, {
    name: 'Trung bình',
    value: 'medium'
  }, {
    name: 'Cao',
    value: 'high'
  },

];

export const projectStatusOptions = [
  {
    name: 'Đang thực hiện',
    value: 'in_progress'
  },
  {
    name: 'Đã xong',
    value: 'completed'
  },
  {
    name: 'Tạm dừng',
    value: 'hold'
  },
  {
    name: 'Chưa xử lý',
    value: 'pending'
  }
];

export const taskTypeOptions = [
  {
    name: 'Task',
    value: 'task'
  },
  {
    name: 'Milestone',
    value: 'milestone'
  },

];

export const defaultProjectValues = {
  name: "",
  description: "",
  content: "",
  start_date: "",
  due_date: "",
  avatar: null,
  status: projectStatusOptions[0].value,
  members: []
};

export const defaultTaskValues = {
  title: '',
  description: '',
  content: '',
  status: 'open',
  assignee_id: null,
  priority: 'medium',
  type: 'task',
  progress: 0,
  start_date: null,
  due_date: null,
  est_time: 0,
  spent_time: 0,
  position: null,
  parents_id: null,
  sprint_id: null,
  tags: [],
};

export const defaultSprintValues = {
  name: "",
  description: "",
  start_date: "",
  end_date: "",
  status: sprintStatus[0].value,
};

export const defaultTagValues = {
  name: "",
  color: "",
};


export const projectStatusVal = {
  'in_progress': 'Đang thực hiện',
  'completed': 'Đã xong',
  'hold': 'Tạm dừng',
  'pending': 'Chưa xử lý',
}

export const projectLabels = {
  'in_progress': 'bg-blue-100 text-blue-700',
  'edit': 'bg-gray-600 text-gray-100',
  'completed': 'bg-green-100 text-green-700',
  'hold': 'bg-pink-100 text-pink-600',
  'pending': 'bg-red-100 text-red-600',
}

export const priorityColors = {
  high: 'bg-red-100 text-red-800',
  medium: 'bg-yellow-100 text-yellow-800',
  low: 'bg-green-100 text-green-800'
};

export const taskLabels = {
  'open': 'bg-blue-100 text-blue-700',
  'closed': 'bg-gray-100 text-gray-700',
}

export const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    ["clean"]
  ]
};

export const formats = [
  "header",
  "bold", "italic", "underline", "strike",
  "list",
  "link", "image"
];

